import { motion } from 'framer-motion'
import { MessageCircle } from 'lucide-react'
import { trackEvent } from '../../analytics'
import { useSiteSettings } from '../../context/SiteSettingsContext'

const DEFAULT_WA_NUMBER = '918200670752'

export function WhatsAppFloat() {
  const { settings } = useSiteSettings()
  const raw = (settings?.whatsapp || '').toString().trim()
  const waNumber = (raw.replace(/[^\d]/g, '') || DEFAULT_WA_NUMBER).replace(/^0+/, '')
  const waUrl = `https://wa.me/${waNumber}`

  return (
    <motion.a
      href={waUrl}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => trackEvent('click', { link_url: waUrl, link_text: 'WhatsApp float', outbound: true })}
      initial={{ opacity: 0, scale: 0.85 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 0.4 }}
      whileHover={{ scale: 1.08 }}
      whileTap={{ scale: 0.95 }}
      className="fixed right-4 sm:right-6 z-40 w-14 h-14 sm:w-12 sm:h-12 rounded-2xl bg-[#25D366] text-white shadow-card flex items-center justify-center min-h-[48px] min-w-[48px] sm:min-h-0 sm:min-w-0 floating-bottom"
      aria-label="Chat on WhatsApp"
    >
      <MessageCircle size={26} strokeWidth={2} className="sm:w-6 sm:h-6" />
    </motion.a>
  )
}
